import { render, staticRenderFns } from "./FormNewPrebidPartner.vue?vue&type=template&id=ffa782be&"
import script from "./FormNewPrebidPartner.vue?vue&type=script&lang=js&"
export * from "./FormNewPrebidPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports